import { CashStackIcon } from "components/Icons/CashStack";
import { EmailIcon } from "components/Icons/Email";
import { FlashIcon } from "components/Icons/Flash";
import { PhoneIcon } from "components/Icons/Phone";
import { PhotoIcon } from "components/Icons/Photo";
import { FormIcon } from "components/Icons/Form";

import { ItemInfo, PhotoTipVariant, TipVariant } from "./types";

export const tips: Record<TipVariant | PhotoTipVariant, ItemInfo> = {
  flashOn: {
    text: (
      <>
        <strong>Dark outside?</strong> Ensure your flash is on
      </>
    ),
    icon: FlashIcon,
    translationKey: "damage_photos.tip.dark",
  },
  uploadFromGallery: {
    text: (
      <>
        <strong>Already taken photos?</strong> Upload photos from your gallery
      </>
    ),
    icon: PhotoIcon,
    translationKey: "damage_photos.tip.gallery",
  },
  phoneCall: {
    text: <>Discuss offer details on a call with a claim handler</>,
    icon: PhoneIcon,
    translationKey: "speedy_payment_options.tip.call",
  },
  email: {
    text: <>We will send the withdrawal decision document and a detailed calculation to the e-mail address provided</>,
    icon: EmailIcon,
    translationKey: "speedy_payment_options.tip.email_docs",
  },
  money: {
    text: <>Receive money in the bank within 2 days. No repair invoices required! </>,
    icon: CashStackIcon,
    translationKey: "speedy_payment_options.tip.receive_money",
  },
  iban: {
    text: <>Provide your IBAN details </>,
    icon: FormIcon,
    translationKey: "speedy_payment_options.tip.provide_iban",
  },
};
